import { RootState } from 'reducers/rootReducer';
import { PayloadAction } from 'types/payloadAction';

const NAME = 'orderDetails';

const SET_ORDER_DETAILS = `${NAME}/SET_ORDER_DETAILS`;

export interface OrderDetailsState {
  readonly companyId: string,
  readonly orderId: string,
  readonly address: string,
}

// Initial State
const initialState: OrderDetailsState = {
  companyId: '',
  orderId: '',
  address: '',
};

// Selectors

const getOrderDetails = (rootState: RootState): OrderDetailsState =>
  rootState.orderDetails;

const getCompanyId = (rootState: RootState): string =>
  rootState.orderDetails.companyId;

const getOrderId = (rootState: RootState): string =>
  rootState.orderDetails.orderId;

const getAddress = (rootState: RootState): string =>
  rootState.orderDetails.address;

export const selectors = {
  getOrderDetails,
  getCompanyId,
  getOrderId,
  getAddress,
};

// Actions
export const actions = {
  setOrderDetails: (payload: OrderDetailsState) => ({
    type: SET_ORDER_DETAILS,
    payload,
  }),
};

// Reducers

const setOrderDetailsReducer = (payload: OrderDetailsState): OrderDetailsState => ({
  companyId: payload.companyId,
  orderId: payload.orderId,
  address: payload.address,
});

export const reducer = (
  state: OrderDetailsState = initialState,
  action: PayloadAction
): OrderDetailsState => {
  switch (action.type) {
    case SET_ORDER_DETAILS:
      return setOrderDetailsReducer(action.payload);

    default:
      return state;
  }
};
